import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_demiray-build/artifacts/cmhgu3sg_3e17e61d-073c-44ff-a45a-e9c574fdca2e-removebg-preview.png";

export const Logo = ({ size = 40, withText = true, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <img
      src={LOGO_URL}
      alt="Demiray İnşaat"
      style={{ width: size, height: size }}
      className="object-contain shrink-0"
    />
    {withText && (
      <div className="leading-none">
        <div className="font-display font-bold text-base tracking-tight text-white">
          DEMİRAY
        </div>
        <div className="text-[10px] tracking-[0.25em] text-[var(--text-muted)] mt-1">
          İNŞAAT
        </div>
      </div>
    )}
  </div>
);

export default Logo;
